import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import theme from './theme';

const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const StudentList = lazy(() => import('./pages/StudentList'));
const StudentBalances = lazy(() => import('./pages/StudentBalances'));
const TeacherList = lazy(() => import('./pages/TeacherList'));
const LessonPackages = lazy(() => import('./pages/LessonPackages'));
const ConsumptionList = lazy(() => import('./pages/ConsumptionList'));
const ScheduleList = lazy(() => import('./pages/ScheduleList'));
const CustomerList = lazy(() => import('./pages/CustomerList'));
const CouponList = lazy(() => import('./pages/CouponList'));
const ArtworkList = lazy(() => import('./pages/ArtworkList'));
const Settings = lazy(() => import('./pages/Settings'));
const CourseManage = lazy(() => import('./pages/CourseManage'));
const ClassManage = lazy(() => import('./pages/ClassManage'));
const AttendanceManage = lazy(() => import('./pages/AttendanceManage'));
const RefundManage = lazy(() => import('./pages/RefundManage'));
const PaymentOrders = lazy(() => import('./pages/PaymentOrders'));
const SalaryManage = lazy(() => import('./pages/SalaryManage'));
const FinanceReport = lazy(() => import('./pages/FinanceReport'));
const GrowthRecords = lazy(() => import('./pages/GrowthRecords'));
const TeacherEvaluation = lazy(() => import('./pages/TeacherEvaluation'));
const NotFound = lazy(() => import('./pages/NotFound'));

const PageLoader = () => <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />;

const App: React.FC = () => {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={theme}
    >
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="students" element={<StudentList />} />
              <Route path="student-balances" element={<StudentBalances />} />
              <Route path="teachers" element={<TeacherList />} />
              <Route path="lesson-packages" element={<LessonPackages />} />
              <Route path="consumptions" element={<ConsumptionList />} />
              <Route path="schedules" element={<ScheduleList />} />
              <Route path="customers" element={<CustomerList />} />
              <Route path="coupons" element={<CouponList />} />
              <Route path="artworks" element={<ArtworkList />} />
              <Route path="settings" element={<Settings />} />
              <Route path="courses" element={<CourseManage />} />
              <Route path="classes" element={<ClassManage />} />
              <Route path="attendance" element={<AttendanceManage />} />
              <Route path="refunds" element={<RefundManage />} />
              <Route path="payments" element={<PaymentOrders />} />
              <Route path="salary" element={<SalaryManage />} />
              <Route path="finance" element={<FinanceReport />} />
              <Route path="growth" element={<GrowthRecords />} />
              <Route path="teacher-evaluation" element={<TeacherEvaluation />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default App;
